<template>
  <div>
    <transition name="modal">
      <div
        class="modal__mask modalParticipanteFundo bg-black bg-opacity-50"
        v-if="showModalCreate"
      >
        <div class="modal__wrapper">
          <div class="modal__container reset bg-white dark:bg-slate-800">
            <div class="content__modal">
              <div class="inner__modal">
                <div class="flex items-center gap-3 mb-6">
                  <img
                    class="w-12 h-12"
                    src="@/assets/addRepresentante.png"
                    alt="Adicionar"
                  />
                  <h2 class="text-lg font-semibold">Adicionar participante</h2>
                </div>
                <form
                  action=""
                  class="form__class"
                  @submit.stop.prevent="createRepresentante"
                >
                  <div class="space-y-4">
                    <div class="form-field">
                      <label class="form-field-label form-field-label-required"
                        >Selecione tipo</label
                      >
                      <ModalSelect class="field" v-model="representante.Tipo"
                        :options="[{ id: '', descricao: 'Selecione' }, { id: 'Diretor', descricao: 'Diretor' }, { id: 'Administrador', descricao: 'Administrador' }]"
                        title="Selecione tipo" placeholder="Selecione" required
                      />
                      <p
                        v-if="camposObrigatorios.erroTipo"
                        class="form-field-error"
                      >
                        Campo obrigatório.
                      </p>
                    </div>

                    <div class="form-field">
                      <InputNome
                        v-model="representante.Nome"
                        label="Nome"
                        :required="true"
                        :erro="camposObrigatorios.erroNome"
                      />
                    </div>

                    <div class="form-field">
                      <label class="form-field-label form-field-label-required"
                        >CPF/CNPJ</label
                      >
                      <input
                        type="text"
                        class="field"
                        autocomplete="off"
                        @click.stop.prevent="clear"
                        v-model="representante.CpfCnpj"
                      />
                      <p
                        v-if="camposObrigatorios.erroCpfCnpj"
                        class="form-field-error"
                      >
                        Campo obrigatório.
                      </p>
                    </div>

                    <div class="form-field">
                      <label class="form-field-label">E-mail</label>
                      <input
                        type="text"
                        class="field"
                        autocomplete="off"
                        @click.stop.prevent="clear"
                        v-model="representante.Email"
                        @blur="validarEmail"
                      />
                      <p v-if="emailErros.email" class="form-field-error">
                        {{ emailErros.email }}
                      </p>
                    </div>

                    <div class="form-field">
                      <telefone-internacional
                        v-model="representante.Telefone"
                        label="Telefone"
                        :name="'Telefone'"
                        :opcional="true"
                        @validate="onValidateTelefone"
                      />
                    </div>

                    <div class="form-field">
                      <label class="form-field-label">Cargo</label>
                      <input
                        type="text"
                        class="field"
                        autocomplete="off"
                        v-model="representante.Cargo"
                        @click.stop.prevent="clear"
                      />
                    </div>

                    <div class="form-field">
                      <label class="form-field-label form-field-label-required"
                        >Assinatura</label
                      >
                      <ModalSelect
                        id="assinante"
                        class="field"
                        v-model="representante.Assinatura"
                        :options="[{ id: '', descricao: 'Selecione' }, { id: '1', descricao: 'Não assina pela empresa' }, { id: '2', descricao: 'Assina isoladamente' }, { id: '0', descricao: 'Assina em conjunto' }]"
                        title="Assinatura" placeholder="Selecione" required
                      />
                      <p
                        v-if="camposObrigatorios.erroAssinatura"
                        class="form-field-error"
                      >
                        Campo obrigatório.
                      </p>
                    </div>
                  </div>

                  <div class="flex gap-3 mt-6">
                    <button
                      class="btn-secondary"
                      type="button"
                      :disabled="disableBtn"
                      @click="closeModal"
                    >
                      Cancelar
                    </button>
                    <button
                      v-if="representante.Guid == ''"
                      class="px-6 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors shadow-sm"
                      type="button"
                      @click="salvarRepresentante"
                    >
                      Adicionar
                    </button>
                    <button
                      v-if="representante.Guid != ''"
                      class="px-6 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors shadow-sm"
                      type="button"
                      @click="salvarRepresentante"
                    >
                      Atualizar
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <ModalAlerta
      :mostrar="modalAlerta.mostrar"
      :tipo="modalAlerta.tipo"
      :titulo="modalAlerta.titulo"
      :mensagem="modalAlerta.mensagem"
      @fechar="modalAlerta.mostrar = false"
    />
  </div>
</template>

<script>
import ModalSelect from "@/components/ModalSelect.vue";
import emailValidatorMixin from "@/utils/emailValidatorMixin.js";
import { mapGetters } from "vuex";
import api from "@/api/axios";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";
import { confirmarReassinatura } from "@/utils/confirmarReassinatura";
import { verificarDocumentoAtivo } from "@/utils/verificarDocumentoAtivo";

export default {
  components: { ModalSelect, ModalAlerta },
  computed: {
    ...mapGetters({
      showModalCreate: "GET_MODAL_FI_ADD_PARTICIPANTE",
      editarRepresentante: "GET_MODAL_FI_EDITAR_PARTICIPANTE",
      user: "auth/user",
    }),
  },
  mixins: [emailValidatorMixin],
  data() {
    return {
      modalAlerta: {
        mostrar: false,
        tipo: "warning",
        titulo: "",
        mensagem: "",
      },
      emailErros: {},
      telefoneValido: [],
      permitirAvancar: false,
      camposObrigatorios: {
        erroTipo: false,
        erroNome: false,
        erroCpfCnpj: false,
        erroAssinatura: false,
      },
      representante: {
        Guid: "",
        Nome: "",
        Email: "",
        Telefone: "",
        Cargo: "",
        CpfCnpj: "",
        Tipo: "",
        Assinatura: "",
      },
    };
  },
  watch: {
    editarRepresentante() {
      if (this.editarRepresentante != null) {
        this.representante = this.editarRepresentante;
        this.validarEmail();
      } else {
        this.limparObj();
      }
    },
  },
  methods: {
    validarEmail() {
      this.validarEmailGeneric(this.representante.Email, "email", {
        obrigatorio: false,
      });
    },
    onValidateTelefone({ name, valid }) {
      if (!this.telefoneValido) {
        this.telefoneValido = {};
      }
      if (valid != "undefined") {
        this.telefoneValido[name] = valid;
      }
    },
    closeModal() {
      this.camposObrigatorios.erroTipo = false;
      this.camposObrigatorios.erroNome = false;
      this.camposObrigatorios.erroCpfCnpj = false;
      this.camposObrigatorios.erroAssinatura = false;
      this.$store.commit("SET_MODAL_FI_ADD_PARTICIPANTE", false);
      this.$store.commit("SET_MODAL_FI_EDITAR_PARTICIPANTE", null);
    },
    limparObj() {
      this.representante = {
        Guid: "", // valor padrão
        Nome: "", // valor padrão
        Email: "", // valor padrão
        Telefone: "",
        Cargo: "",
        CpfCnpj: "", // valor padrão
        Tipo: "", // valor padrão
        Assinatura: "",
      };
    },
    validarFormulario(submeter) {
      this.permitirAvancar = true;
      var nomeDoCampo = "";
      var valorInvalido = false;
      this.camposObrigatorios = {
        erroTipo: false,
        erroNome: false,
        erroCpfCnpj: false,
        erroAssinatura: false,
      };
      if (
        this.representante.Tipo === null ||
        this.representante.Tipo === undefined ||
        this.representante.Tipo === ""
      ) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroTipo = true;
          nomeDoCampo = "Tipo";
        }
        this.permitirAvancar = false;
      }
      if (!this.representante.Nome) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroNome = true;
          nomeDoCampo = "Nome";
        }
        this.permitirAvancar = false;
      }
      if (!this.representante.CpfCnpj) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroCpfCnpj = true;
          nomeDoCampo = "CPF/CNPJ";
        }
        this.permitirAvancar = false;
      }

      const telefoneValido = this.telefoneValido[`Telefone`];

      if (
        this.representante.Telefone.length > 4 &&
        (!this.representante.Telefone || telefoneValido == false)
      ) {
        if (submeter && this.permitirAvancar) {
          nomeDoCampo = "Telefone";
        }
        if (telefoneValido == false) {
          valorInvalido = true;
        }
        this.permitirAvancar = false;
      }

      if (
        this.representante.Assinatura === null ||
        this.representante.Assinatura === undefined ||
        this.representante.Assinatura === ""
      ) {
        if (submeter && this.permitirAvancar) {
          this.camposObrigatorios.erroAssinatura = true;
          nomeDoCampo = "Assinatura";
        }
        this.permitirAvancar = false;
      }
      if (Object.values(this.emailErros).some((erro) => erro !== "")) {
        if (submeter && this.permitirAvancar) {
          nomeDoCampo = "E-mail";
        }
        this.permitirAvancar = false;
      }
      if (submeter && nomeDoCampo != "") {
        if (valorInvalido) {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: Campo obrigatório",
            mensagem: `O campo ${nomeDoCampo} foi informado, mas não foi preenchido corretamente. Preencha a informação para avançar.`,
          };
        } else {
          this.modalAlerta = {
            mostrar: true,
            tipo: "warning",
            titulo: "Atenção: Campo obrigatório",
            mensagem: `O campo ${nomeDoCampo} não foi informado ou é inválido, preencha a informação para avançar.`,
          };
        }
      }
    },
    async salvarRepresentante() {
      this.validarFormulario(true);
      if (this.permitirAvancar) {
        this.disableBtn = true;

        if (
          (this.representante.Guid == "" &&
            String(this.representante.Assinatura) != "1") ||
          this.representante.Guid != ""
        ) {
          var documentoAtivo = await verificarDocumentoAtivo();

          if (documentoAtivo) {
            var confirmado = await confirmarReassinatura();
            if (!confirmado) {
              return;
            }
          }
        }

        await api
          .post("/Fundo/emissorOrdem", this.representante)
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$swal({
                icon: "success",
                title:
                  this.representante.Guid == ""
                    ? "Inclusão realizada com sucesso!"
                    : "Alteração realizada com sucesso!",
                text: "Dados informados foram salvos com sucesso.",
              });
              this.limparObj();
              this.$store.commit("SET_MODAL_FI_ADD_PARTICIPANTE", false);
              this.$store.dispatch("FETCH_FI_INFO_PARTICIPANTE_CUSTODIANTE");
            }
          })
          .catch((error) => {
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos.",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
  },
};
</script>
